/** @jsx jsx */
import { css, jsx } from "@emotion/react"
import { useTheme } from "components/common/Context/ThemeContext"
import PropTypes, { string } from "prop-types"

const Legend = ({
  disabled = false,
  selected = false,
  onClick,
  dataTestId = "",
  text = "",
  color
}) => {
  const useStyles = (theme) => {
    return {
      customBtn: css`
        display: flex;
        align-items: center;
        font-size: 0.75rem;
        font-family: theme.fontFamilyRegular;
        min-height: 2.1875rem;
        min-width: fit-content;
        border: ${selected
          ? `1px solid ${theme.btnSecondaryBorderColor}`
          : "1px solid transparent"};
        background-color: ${selected ? theme.btnBgSecondaryColor : "unset"};
        max-width: 17rem;
        border-radius: 4px;
        white-space: normal;
        text-align: left;
        line-height: 0.9rem;
        padding: 5px 10px;
        margin: 4px 8px 4px 0;
        cursor: ${disabled ? "not-allowed" : "pointer"};
        opacity: ${disabled ? 0.4 : 1};
        color: theme.btnSecondaryColor;
        &:hover,
        &:focus {
          border: 1px solid
            ${selected
              ? theme.btnSecondaryBorderColor
              : theme.focusedLegendColor};
          box-shadow: 0px 1px 4px ${theme.boxShadowColor};
          outline: none;
        }
        &:active {
          background-color: ${theme.btnBgSecondaryColor};
          border: 1px solid ${theme.btnSecondaryBorderColor};
          box-shadow: 0px 1px 4px ${theme.boxShadowColor};
          outline: none;
        }
      `,
      legendBox: css`
        min-width: 10px;
        width: 10px;
        height: 20px;
        margin-right: 0.5rem;
        background-color: ${color};
      `,
      legendText: css`
        font-family: ${theme.fontFamily};
        font-color: ${theme.primaryTextColor};
        line-break: auto;
      `
    }
  }

  const theme = useTheme()
  const classes = useStyles(theme)

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={dataTestId}
      css={classes.customBtn}
    >
      <div css={classes.legendBox} />
      <div>
        <span data-testid="legend-text" css={classes.legendText}>
          {text}
        </span>
      </div>
    </button>
  )
}
export default Legend

Legend.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.string,
  selected: PropTypes.bool,
  dataTestId: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string,PropTypes.object]),
  color: string,
  className: PropTypes.string
}
